import { GQLBigTextFragment } from '@theprintbar/graphql';
import { BrandColours, cn } from '@theprintbar/shared';
import { BrandStarAnimated } from '@theprintbar/ui';

interface BigTextProps {
	content: GQLBigTextFragment;
}

export function BigText({ content }: BigTextProps) {
	const { bigTextText, bigTextTitle, bigTextIcon, bigTextSticker, bigTextColour } = content;

	const stickerTop = bigTextSticker?.[0];
	const stickerBottom = bigTextSticker?.[1];

	const icon = bigTextIcon ? (
		<img loading="lazy" alt={bigTextIcon.altText || 'sticker'} src={bigTextIcon.image.url} className="h-6 w-6" />
	) : (
		<BrandStarAnimated className={cn('h-6 w-6 fill-blue', bigTextColour === BrandColours.Blue && 'fill-white')} />
	);

	return (
		<section
			className="relative bg-white-preal flex flex-col gap-12 items-center w-full px-4 py-36"
			style={{ backgroundColor: bigTextColour || undefined }}
		>
			{/* Sticker 1 */}
			{stickerTop && (
				<img
					loading="lazy"
					alt={stickerTop.altText || 'sticker'}
					src={stickerTop.image.url}
					className="absolute h-28 w-28 rounded-full right-4 lg:right-16 lg:top-28 top-14"
				/>
			)}

			{/* BrandStar Icon */}
			{icon}

			{/* Main Text */}
			<h2
				className={cn(
					'text-[50px] xl:text-[80px] uppercase font-gravity font-black leading-[65px] max-w-md lg:max-w-2xl xl:max-w-4xl text-center',
					bigTextColour === BrandColours.Blue && 'text-white',
				)}
			>
				{bigTextTitle}
			</h2>

			{/* Sub Text */}
			{bigTextText && (
				<p
					className={cn(
						'lg:text-base text-sm max-w-sm lg:max-w-xl xl:max-w-3xl text-center',
						bigTextColour === BrandColours.Blue && 'text-white',
					)}
				>
					{bigTextText}
				</p>
			)}

			{/* BrandStar Icon */}
			{icon}

			{/* Sticker 2 */}
			{stickerBottom && (
				<img
					loading="lazy"
					alt={stickerBottom.altText || 'sticker'}
					src={stickerBottom.image.url}
					className="absolute h-28 w-28 rounded-full left-4 lg:left-16 lg:bottom-28 bottom-14"
				/>
			)}
		</section>
	);
}
